export default class Testimonials {
    constructor() {
        this.container = document.querySelector('.testimonials');

        this.init();
    }
    init() {
        this.initListeners();
    }

    initListeners() {
        this.container.querySelector('.js-view-more').addEventListener('click', (e) => {
            const button = e.currentTarget;
            const collapsibleContainer = this.container.querySelector('.collapse-on-mobile');

            button.classList.toggle('active');
            if (button.classList.contains('active')) {
                button.innerHTML = 'See less';

                collapsibleContainer.scrollIntoView({
                    behavior: 'smooth'
                });
            } else {
                button.innerHTML = 'View more';

                this.container.scrollIntoView({
                    behavior: 'smooth'
                });
            }

            collapsibleContainer.classList.toggle('collapsed');
        })
    }

}
